// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_GET_URL_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/getUrl.js");
var ___CSS_LOADER_URL_IMPORT_0___ = require("../../../public/SiteImages/fondo-ondulado-para-personaje.svg");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ExistingPage-space1-RhrA5 {
	margin-bottom: 6px !important;
}

.ExistingPage-space2-KXdcl {
	margin-bottom: 12px !important;
}

.ExistingPage-space3-PyeNc {
	margin-bottom: 18px !important;
}

.ExistingPage-space4-KQrao {
	margin-bottom: 24px !important;
}

.ExistingPage-space5-i9eKx {
	margin-bottom: 30px !important;
}

.ExistingPage-space6-UpI0P {
	margin-bottom: 36px !important;
}

.ExistingPage-space7-vHYnS {
	margin-bottom: 42px !important;
}

.ExistingPage-spaceTop8-GqvJa {
	margin-bottom: 48px !important;
}

.ExistingPage-spaceTop1-sHJA5 {
	margin-top: 6px !important;
}

.ExistingPage-spaceTop2-JGeX9 {
	margin-top: 12px !important;
}

.ExistingPage-spaceTop3-XgVrn {
	margin-top: 18px !important;
}

.ExistingPage-spaceTop4-Ds6Zf {
	margin-top: 24px !important;
}

.ExistingPage-spaceTop5-Kyop1 {
	margin-top: 30px !important;
}

.ExistingPage-spaceTop6-moSYM {
	margin-top: 36px !important;
}

.ExistingPage-spaceTop7-P8QhP {
	margin-top: 42px !important;
}

.ExistingPage-spaceTop8-GqvJa {
	margin-top: 48px !important;
}

.ExistingPage-noMargin-h2xLH {
	margin: 0px !important;
}

.ExistingPage-padding1-NRv14 {
	padding-bottom: 6px !important;
}

.ExistingPage-padding2-IB35q {
	padding-bottom: 12px !important;
}

.ExistingPage-padding3-wDVvv {
	padding-bottom: 18px !important;
}

.ExistingPage-padding4-dbz7W {
	padding-bottom: 24px !important;
}

.ExistingPage-padding5-qqmcy {
	padding-bottom: 30px !important;
}

.ExistingPage-padding6-i4EEr {
	padding-bottom: 36px !important;
}

.ExistingPage-padding7-RulE5 {
	padding-bottom: 42px !important;
}

.ExistingPage-paddingTop1-qVAKn {
	padding-top: 6px !important;
}

.ExistingPage-paddingTop2-tIODS {
	padding-top: 12px !important;
}

.ExistingPage-paddingTop3-NTwmM {
	padding-top: 18px !important;
}

.ExistingPage-paddingTop4-Wdmha {
	padding-top: 24px !important;
}

.ExistingPage-paddingTop5-wLrkb {
	padding-top: 30px !important;
}

.ExistingPage-paddingTop6-INIz3 {
	padding-top: 36px !important;
}

.ExistingPage-paddingTop7-VzDCc {
	padding-top: 42px !important;
}

.ExistingPage-noPadding-oFnIy {
	padding: 0px !important;
}

.ExistingPage-textBold-Apo_h {
	font-weight: 500 !important;
}

.ExistingPage-textBolder-HzQAw {
	font-weight: 700 !important;
}

.ExistingPage-textNormal-E8929 {
	font-weight: normal !important;
}

.ExistingPage-spaceBottom20-aL13P {
	margin-bottom: 20px;
}

.ExistingPage-spaceBottom10-kz8dv {
	margin-bottom: 10px;
}

.ExistingPage-marginNone-j8bkT {
	margin: 0;
}

.ExistingPage-spaceBottom15-gH5ht {
	margin-bottom: 15px;
}

.ExistingPage-marginTopNone-eTmfj {
	margin-top: 0;
}

.ExistingPage-spaceTop11-hNenj {
	margin-top: 11px;
}

.ExistingPage-spaceTop21-eRo70 {
	margin-top: 21px;
}

.ExistingPage-spaceTop20-GRcs6 {
	margin-top: 20px;
}

.ExistingPage-spaceTop10-l9_Aa {
	margin-top: 10px;
}

/*New Design Text Colors */

.ExistingPage-textDarkBlue-xAeFT {
	color: rgb(20, 39, 94) !important;
}

.ExistingPage-textLightBlue-CbfZm {
	color: rgb(57, 87, 106) !important;
}

.ExistingPage-textLightSandleGreen-IL5rO {
	color: rgb(76, 86, 41) !important;
}

.ExistingPage-textLightBrown-vIx9S {
	color: rgb(115, 79, 33) !important;
}

.ExistingPage-textMediumMaroon-ky0ug {
	color: rgb(87, 37, 51) !important;
}

.ExistingPage-textBrown-AvptE {
	color: rgb(160, 47, 24) !important;
}

.ExistingPage-textMaroon-ThZLW {
	color: rgb(155, 49, 67) !important;
}

.ExistingPage-textDarkBrown-dRt_d {
	color: rgb(83, 18, 16) !important;
}

.ExistingPage-textMediumBrown-FAlJ4 {
	color: rgb(142, 28, 10) !important;
}

.ExistingPage-textSkyBlue-bOZMH {
	color: rgb(37, 117, 141) !important;
}

.ExistingPage-textGray-x5cZ6 {
	color: rgb(77, 65, 51) !important;
}

/* Page Wrapper with soft wavy background */

.ExistingPage-pageRoot-siyxP {
	position: relative;
	min-height: 100vh;
	width: 100%;
	background: -webkit-gradient(linear, left top, left bottom, from(#f6faff), color-stop(55%, #edf5fd), to(#e9f3fd));
	background: linear-gradient(180deg, #f6faff 0%, #edf5fd 55%, #e9f3fd 100%);
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-orient: vertical;
	-webkit-box-direction: normal;
	    -ms-flex-direction: column;
	        flex-direction: column;
	-webkit-box-sizing: border-box;
	        box-sizing: border-box;
	overflow: hidden;
	font-family: var(--font-family-base);
}

/* Top waves (white/light layers over the soft blue base) */

.ExistingPage-pageRoot-siyxP::before {
	content: '';
	position: absolute;
	top: 0;
	left: 0;
	width: 100%;
	height: clamp(160px, 24vw, 220px);
	background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 1440 260' preserveAspectRatio='none'%3E%3Cpath fill='%23ffffff' fill-opacity='0.6' d='M0,95 C180,80 300,150 520,160 C760,172 900,85 1120,95 C1280,102 1370,75 1440,60 L1440,0 L0,0 Z'/%3E%3Cpath fill='%23f8fbff' fill-opacity='0.8' d='M0,50 C220,40 340,105 560,110 C800,115 960,50 1160,60 C1300,66 1380,45 1440,35 L1440,0 L0,0 Z'/%3E%3C/svg%3E");
	background-repeat: no-repeat;
	background-position: top center;
	background-size: 100% 100%;
	pointer-events: none;
	z-index: 0;
}

/* Bottom waves (soft blue layers) */

.ExistingPage-pageRoot-siyxP::after {
	content: '';
	position: absolute;
	bottom: 0;
	left: 0;
	width: 100%;
	height: clamp(140px, 20vw, 170px);
	background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 1440 220' preserveAspectRatio='none'%3E%3Cpath fill='%23d9eafb' fill-opacity='0.6' d='M0,150 C200,110 380,170 620,165 C860,160 1040,110 1250,125 C1350,132 1410,150 1440,160 L1440,220 L0,220 Z'/%3E%3C/svg%3E");
	background-repeat: no-repeat;
	background-position: bottom center;
	background-size: 100% 100%;
	pointer-events: none;
	z-index: 0;
}

/* Header */

.ExistingPage-pageHeader-AgJ9D {
	width: 100%;
	background: transparent;
	padding: 18px 48px;
	-webkit-box-sizing: border-box;
	        box-sizing: border-box;
	position: relative;
	z-index: 100;
}

.ExistingPage-headerInner-aeAFr {
	margin: 0 auto;
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
	-webkit-box-pack: justify;
	    -ms-flex-pack: justify;
	        justify-content: space-between;
	width: 100%;
}

.ExistingPage-headerLeft-C17lc {
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
}

.ExistingPage-headerLogoLink-mKC8m {
	display: -webkit-inline-box;
	display: -ms-inline-flexbox;
	display: inline-flex;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
	text-decoration: none;
}

.ExistingPage-headerLogo-fVWo9 {
	height: 38px;
	width: auto;
	-o-object-fit: contain;
	   object-fit: contain;
}

.ExistingPage-headerNav-BaQ4U {
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
	gap: 22px;
}

.ExistingPage-headerNavLink-ROrZz {
	color: var(--secondary-oscuro);
	font-size: 15px;
	font-weight: 500;
	font-family: var(--font-family-base);
	text-decoration: none;
	-webkit-transition: color 0.2s ease;
	transition: color 0.2s ease;
	line-height: 1;
}

.ExistingPage-headerNavLink-ROrZz:hover,
.ExistingPage-headerNavLink-ROrZz:focus {
	color: var(--primary-color);
	text-decoration: none;
}

.ExistingPage-headerNavLinkActive-QtZn5 {
	color: var(--secondary-oscuro);
	font-weight: 600;
}

.ExistingPage-navDivider-DdFEg {
	width: 1.5px;
	height: 50px;
	background-color: #cbd5e1;
	display: inline-block;
}

.ExistingPage-headerRight-FHCE_ {
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
}

.ExistingPage-dropdownBtn-KUBLG {
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
	cursor: pointer;
}

/* Mobile slide menu */

.ExistingPage-mobileMenu-mXt7r {
	position: fixed;
	top: 0;
	right: -100%;
	width: 100%;
	max-width: 380px;
	height: 100vh;
	background: var(--background-primary);
	z-index: 1050;
	-webkit-transition: right 0.35s ease;
	transition: right 0.35s ease;
	overflow-y: auto;
	-webkit-box-shadow: -4px 0 20px rgba(0, 0, 0, 0.15);
	        box-shadow: -4px 0 20px rgba(0, 0, 0, 0.15);
	padding: 24px 20px;
	-webkit-box-sizing: border-box;
	        box-sizing: border-box;
}

.ExistingPage-menuOpen-zKrwt {
	right: 0 !important;
}

.ExistingPage-closeButtonPosition-kmmne {
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-pack: end;
	    -ms-flex-pack: end;
	        justify-content: flex-end;
	margin-bottom: 20px;
}

.ExistingPage-closeColor-Amjhx {
	cursor: pointer;
	padding: 8px;
}

.ExistingPage-closeColor-Amjhx img {
	width: 18px;
	height: 18px;
}

.ExistingPage-mobileMenuContent-hO_6w {
	width: 100%;
}

/* Main Content Section */

.ExistingPage-mainContainer-B7VJZ {
	position: relative;
	z-index: 1;
	-webkit-box-flex: 1;
	    -ms-flex: 1 1;
	        flex: 1 1;
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
	-webkit-box-pack: center;
	    -ms-flex-pack: center;
	        justify-content: center;
	padding: 20px 32px 60px;
	-webkit-box-sizing: border-box;
	        box-sizing: border-box;
	width: 100%;
}

.ExistingPage-cardsGrid-Yf4kG {
	max-width: 1510px;
	width: 100%;
	margin: 0 auto;
	display: grid;
	grid-template-columns: 0.6fr 1fr;
	gap: 32px;
	-webkit-box-align: stretch;
	    -ms-flex-align: stretch;
	        align-items: stretch;
}

/* Left Card (Greeting & Character) */

.ExistingPage-leftCard-RspeV {
	/* background: linear-gradient(180deg, rgba(236, 245, 253, 0.92) 0%, rgba(228, 240, 252, 0.92) 100%); */
	background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
	background-repeat: no-repeat;
	background-position: center center;
	background-size: contain;
	border-radius: 30px;
	padding: 44px 32px 40px;
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-orient: vertical;
	-webkit-box-direction: normal;
	    -ms-flex-direction: column;
	        flex-direction: column;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
	-webkit-box-pack: center;
	    -ms-flex-pack: center;
	        justify-content: center;
	text-align: center;
	-webkit-box-shadow: 0 10px 40px rgba(0, 52, 83, 0.04);
	        box-shadow: 0 10px 40px rgba(0, 52, 83, 0.04);
	-webkit-box-sizing: border-box;
	        box-sizing: border-box;
}

.ExistingPage-illustrationWrapper-YUnGc {
	width: 100%;
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-pack: center;
	    -ms-flex-pack: center;
	        justify-content: center;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
	margin-bottom: 24px;
}

.ExistingPage-illustrationImg-gxJ8_ {
	width: 100%;
	max-width: 340px;
	height: auto;
	-o-object-fit: contain;
	   object-fit: contain;
}

.ExistingPage-leftTitle-UgSxS {
	color: var(--secondary-oscuro);
	font-family: var(--font-family-base);
	font-size: 42px;
	font-weight: 800;
	letter-spacing: -0.5px;
	margin: 0 0 12px 0;
	line-height: 1.2;
}

.ExistingPage-leftUserName-bNZpf {
	color: var(--primary-color);
}

.ExistingPage-leftSubtitle-HXmxN {
	color: #4b5563;
	font-family: var(--font-family-base);
	font-size: 17px;
	font-weight: 400;
	line-height: 1.5;
	max-width: 340px;
	margin: 0 auto;
}

/* Right Card (Steps List) */

.ExistingPage-rightCard-CC8VH {
	background: rgba(255, 255, 255, 0.78);
	border-radius: 30px;
	padding: 44px 44px 36px;
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-orient: vertical;
	-webkit-box-direction: normal;
	    -ms-flex-direction: column;
	        flex-direction: column;
	-webkit-box-pack: center;
	    -ms-flex-pack: center;
	        justify-content: center;
	-webkit-box-shadow: 0 10px 40px rgba(0, 52, 83, 0.05), 0 2px 10px rgba(0, 0, 0, 0.015);
	        box-shadow: 0 10px 40px rgba(0, 52, 83, 0.05), 0 2px 10px rgba(0, 0, 0, 0.015);
	-webkit-box-sizing: border-box;
	        box-sizing: border-box;
}

.ExistingPage-stepsList-P4w90 {
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-orient: vertical;
	-webkit-box-direction: normal;
	    -ms-flex-direction: column;
	        flex-direction: column;
	width: 100%;
}

.ExistingPage-stepItem-a7rjc {
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
	-webkit-box-pack: justify;
	    -ms-flex-pack: justify;
	        justify-content: space-between;
	gap: 20px;
	padding: 6px 0;
	-webkit-box-sizing: border-box;
	        box-sizing: border-box;
	-webkit-transition: background-color 0.2s ease;
	transition: background-color 0.2s ease;
	border-radius: 16px;
}

.ExistingPage-stepLeft-Uyzld {
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-align: start;
	    -ms-flex-align: start;
	        align-items: flex-start;
	gap: 22px;
	-webkit-box-flex: 1;
	    -ms-flex: 1 1;
	        flex: 1 1;
}

.ExistingPage-stepIconCircle-W17Dt {
	width: 58px;
	height: 58px;
	border-radius: 50%;
	background-color: #e4effc;
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
	-webkit-box-pack: center;
	    -ms-flex-pack: center;
	        justify-content: center;
	-ms-flex-negative: 0;
	    flex-shrink: 0;
	position: relative;
	color: var(--secondary-oscuro);
	margin-top: 2px;
	-webkit-transition: all 0.2s ease;
	transition: all 0.2s ease;
}

.ExistingPage-stepIconCircleCompleted-NCtmy {
	background-color: #d9eafb;
	color: var(--secondary-oscuro);
}

.ExistingPage-stepIconImg-FU_XZ {
	width: 24px;
	height: 24px;
	-o-object-fit: contain;
	   object-fit: contain;
}

/* .stepIconCircleCompleted .stepIconImg {
	filter: brightness(0) invert(1);
} */

.ExistingPage-stepSvgIcon-v8Q82 {
	width: 24px;
	height: 24px;
	display: block;
}

.ExistingPage-stepTickIcon-l7CEm {
	position: absolute;
	bottom: -2px;
	right: -2px;
	width: 18px;
	height: 18px;
	border-radius: 50%;
	background: #ffffff;
	color: var(--primary-color);
	-webkit-box-shadow: 0 2px 6px rgba(0, 0, 0, 0.15);
	        box-shadow: 0 2px 6px rgba(0, 0, 0, 0.15);
}

.ExistingPage-stepDetails-HYwwR {
	-webkit-box-flex: 1;
	    -ms-flex: 1 1;
	        flex: 1 1;
}

.ExistingPage-stepTitle-Z4aGv {
	color: var(--primary-color);
	font-family: var(--font-family-base) !important;
	font-size: 26px;
	font-weight: 700;
	margin: 0 0 6px 0;
	line-height: 1.25;
	cursor: pointer;
	letter-spacing: -0.3px;
}

.ExistingPage-stepTitle-Z4aGv:hover {
	opacity: 0.85;
}

.ExistingPage-stepDescription-WWHG8 {
	color: #4b5563;
	font-family: var(--font-family-base);
	font-size: 16px;
	font-weight: 400;
	line-height: 1.5;
	margin: 0;
	max-width: 520px;
}

.ExistingPage-stepAction-rl5cv {
	-ms-flex-negative: 0;
	    flex-shrink: 0;
	margin-left: 16px;
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
}

.ExistingPage-actionLink-mWmrx {
	color: var(--primary-color);
	font-family: var(--font-family-base);
	font-size: 16px;
	font-weight: 500;
	text-decoration: none;
	display: -webkit-inline-box;
	display: -ms-inline-flexbox;
	display: inline-flex;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
	gap: 6px;
	cursor: pointer;
	-webkit-transition: opacity 0.2s ease;
	transition: opacity 0.2s ease;
}

.ExistingPage-actionLink-mWmrx:hover,
.ExistingPage-actionLink-mWmrx:focus {
	color: var(--primary-color);
	text-decoration: none;
	opacity: 0.8;
}

.ExistingPage-chevronIcon-LMIbc {
	font-size: 22px;
	font-weight: 600;
	line-height: 1;
}

.ExistingPage-chevronDisabled-BUx9e {
	color: #64748b;
	font-size: 26px;
	font-weight: 400;
	line-height: 1;
	cursor: pointer;
	padding: 4px;
	-webkit-transition: color 0.2s ease;
	transition: color 0.2s ease;
}

.ExistingPage-chevronDisabled-BUx9e:hover {
	color: var(--primary-color);
}

.ExistingPage-stepDivider-uYIgR {
	height: 1px;
	background-color: #e6edf4;
	width: 100%;
	margin: 26px 0;
}

/* Grid Footer (Publish / Admin status) */

.ExistingPage-gridFooter-kncyJ {
	margin-top: 24px;
	width: 100%;
}

.ExistingPage-listNextPosition-o8el4 {
	width: 100%;
	padding-top: 16px;
	border-top: 1px solid #e6edf4;
}

.ExistingPage-listNextBackButton-Jup8e {
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
	-webkit-box-pack: justify;
	    -ms-flex-pack: justify;
	        justify-content: space-between;
	-ms-flex-wrap: wrap;
	    flex-wrap: wrap;
	gap: 16px;
	width: 100%;
}

.ExistingPage-textColor-bzt0C {
	font-size: 15px;
	color: var(--secondary-oscuro);
	margin: 0;
	font-weight: 600;
}

.ExistingPage-spaceTop1-sHJA5 {
	margin-top: 0;
}

.ExistingPage-btnFlex-wDTIB {
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
	gap: 12px;
	-ms-flex-wrap: wrap;
	    flex-wrap: wrap;
}

.ExistingPage-displayInline-c100V {
	display: inline-block;
}

.ExistingPage-formSelect-qyOkk {
	font-size: 15px;
	border: 1px solid var(--primary-color);
	background-color: var(--primary-color);
	color: #ffffff;
	font-weight: 600;
	border-radius: 999px;
	padding: 8px 32px 8px 18px;
	width: auto;
	cursor: pointer;
}

.ExistingPage-flexEnd-btFc1 {
	-webkit-box-pack: end;
	    -ms-flex-pack: end;
	        justify-content: flex-end;
}

.ExistingPage-flexCenter-ah2wV {
	-webkit-box-pack: center;
	    -ms-flex-pack: center;
	        justify-content: center;
}

/* Responsive Media Queries */

@media screen and (max-width: 1080px) {
	.ExistingPage-headerNav-BaQ4U {
		display: none;
	}

	.ExistingPage-cardsGrid-Yf4kG {
		grid-template-columns: 360px 1fr;
		gap: 24px;
	}

	.ExistingPage-leftCard-RspeV {
		padding: 36px 24px;
	}

	.ExistingPage-rightCard-CC8VH {
		padding: 36px 28px;
	}

	.ExistingPage-leftTitle-UgSxS {
		font-size: 32px;
	}

	.ExistingPage-stepTitle-Z4aGv {
		font-size: 22px;
	}

	.ExistingPage-stepDescription-WWHG8 {
		font-size: 15px;
	}
}

@media screen and (max-width: 860px) {
	.ExistingPage-pageHeader-AgJ9D {
		padding: 14px 20px;
	}

	.ExistingPage-mainContainer-B7VJZ {
		padding: 12px 16px 36px;
	}

	.ExistingPage-cardsGrid-Yf4kG {
		grid-template-columns: 100%;
		max-width: 620px;
		gap: 24px;
	}

	.ExistingPage-leftCard-RspeV {
		padding: 32px 20px;
	}

	.ExistingPage-rightCard-CC8VH {
		padding: 32px 20px;
	}

	.ExistingPage-illustrationImg-gxJ8_ {
		max-width: 260px;
	}

	.ExistingPage-stepTitle-Z4aGv {
		font-size: 19px;
	}

	.ExistingPage-stepDescription-WWHG8 {
		font-size: 14px;
	}

	.ExistingPage-stepItem-a7rjc {
		gap: 12px;
	}

	.ExistingPage-stepLeft-Uyzld {
		gap: 14px;
	}

	.ExistingPage-stepIconCircle-W17Dt {
		width: 44px;
		height: 44px;
	}

	.ExistingPage-stepIconImg-FU_XZ,
	.ExistingPage-stepSvgIcon-v8Q82 {
		width: 18px;
		height: 18px;
	}

	.ExistingPage-stepDivider-uYIgR {
		margin: 20px 0;
	}
}`, "",{"version":3,"sources":["webpack://./src/components/helpers.css","webpack://./src/components/ListPlaceStep1/ExistingPage.css"],"names":[],"mappings":"AAAA;CACC,6BAA6B;AAC9B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,0BAA0B;AAC3B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,sBAAsB;AACvB;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,uBAAuB;AACxB;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,SAAS;AACV;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA,0BAA0B;;AAE1B;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,mCAAmC;AACpC;;AAEA;CACC,iCAAiC;AAClC;;AC1NA,2CAA2C;;AAC3C;CACC,kBAAkB;CAClB,iBAAiB;CACjB,WAAW;CACX,iHAA0E;CAA1E,0EAA0E;CAC1E,oBAAa;CAAb,oBAAa;CAAb,aAAa;CACb,4BAAsB;CAAtB,6BAAsB;KAAtB,0BAAsB;SAAtB,sBAAsB;CACtB,8BAAsB;SAAtB,sBAAsB;CACtB,gBAAgB;CAChB,oCAAoC;AACrC;;AAEA,2DAA2D;;AAC3D;CACC,WAAW;CACX,kBAAkB;CAClB,MAAM;CACN,OAAO;CACP,WAAW;CACX,iCAAiC;CACjC,ubAAub;CACvb,4BAA4B;CAC5B,+BAA+B;CAC/B,0BAA0B;CAC1B,oBAAoB;CACpB,UAAU;AACX;;AAEA,oCAAoC;;AACpC;CACC,WAAW;CACX,kBAAkB;CAClB,SAAS;CACT,OAAO;CACP,WAAW;CACX,iCAAiC;CACjC,iTAAiT;CACjT,4BAA4B;CAC5B,kCAAkC;CAClC,0BAA0B;CAC1B,oBAAoB;CACpB,UAAU;AACX;;AAEA,WAAW;;AACX;CACC,WAAW;CACX,uBAAuB;CACvB,kBAAkB;CAClB,8BAAsB;SAAtB,sBAAsB;CACtB,kBAAkB;CAClB,YAAY;AACb;;AAEA;CACC,cAAc;CACd,oBAAa;CAAb,oBAAa;CAAb,aAAa;CACb,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;CACnB,yBAA8B;KAA9B,sBAA8B;SAA9B,8BAA8B;CAC9B,WAAW;AACZ;;AAEA;CACC,oBAAa;CAAb,oBAAa;CAAb,aAAa;CACb,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;AACpB;;AAEA;CACC,2BAAoB;CAApB,2BAAoB;CAApB,oBAAoB;CACpB,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;CACnB,qBAAqB;AACtB;;AAEA;CACC,YAAY;CACZ,WAAW;CACX,sBAAmB;IAAnB,mBAAmB;AACpB;;AAEA;CACC,oBAAa;CAAb,oBAAa;CAAb,aAAa;CACb,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;CACnB,SAAS;AACV;;AAEA;CACC,8BAA8B;CAC9B,eAAe;CACf,gBAAgB;CAChB,oCAAoC;CACpC,qBAAqB;CACrB,mCAA2B;CAA3B,2BAA2B;CAC3B,cAAc;AACf;;AAEA;;CAEC,2BAA2B;CAC3B,qBAAqB;AACtB;;AAEA;CACC,8BAA8B;CAC9B,gBAAgB;AACjB;;AAEA;CACC,YAAY;CACZ,YAAY;CACZ,yBAAyB;CACzB,qBAAqB;AACtB;;AAEA;CACC,oBAAa;CAAb,oBAAa;CAAb,aAAa;CACb,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;AACpB;;AAEA;CACC,oBAAa;CAAb,oBAAa;CAAb,aAAa;CACb,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;CACnB,eAAe;AAChB;;AAEA,sBAAsB;;AACtB;CACC,eAAe;CACf,MAAM;CACN,YAAY;CACZ,WAAW;CACX,gBAAgB;CAChB,aAAa;CACb,qCAAqC;CACrC,aAAa;CACb,oCAA4B;CAA5B,4BAA4B;CAC5B,gBAAgB;CAChB,mDAA2C;SAA3C,2CAA2C;CAC3C,kBAAkB;CAClB,8BAAsB;SAAtB,sBAAsB;AACvB;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,oBAAa;CAAb,oBAAa;CAAb,aAAa;CACb,qBAAyB;KAAzB,kBAAyB;SAAzB,yBAAyB;CACzB,mBAAmB;AACpB;;AAEA;CACC,eAAe;CACf,YAAY;AACb;;AAEA;CACC,WAAW;CACX,YAAY;AACb;;AAEA;CACC,WAAW;AACZ;;AAEA,yBAAyB;;AACzB;CACC,kBAAkB;CAClB,UAAU;CACV,mBAAO;KAAP,aAAO;SAAP,SAAO;CACP,oBAAa;CAAb,oBAAa;CAAb,aAAa;CACb,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;CACnB,wBAAuB;KAAvB,qBAAuB;SAAvB,uBAAuB;CACvB,uBAAuB;CACvB,8BAAsB;SAAtB,sBAAsB;CACtB,WAAW;AACZ;;AAEA;CACC,iBAAiB;CACjB,WAAW;CACX,cAAc;CACd,aAAa;CACb,gCAAgC;CAChC,SAAS;CACT,0BAAoB;KAApB,uBAAoB;SAApB,oBAAoB;AACrB;;AAEA,qCAAqC;;AACrC;CACC,uGAAuG;CACvG,yDAA6E;CAC7E,4BAA4B;CAC5B,kCAAkC;CAClC,wBAAwB;CACxB,mBAAmB;CACnB,uBAAuB;CACvB,oBAAa;CAAb,oBAAa;CAAb,aAAa;CACb,4BAAsB;CAAtB,6BAAsB;KAAtB,0BAAsB;SAAtB,sBAAsB;CACtB,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;CACnB,wBAAuB;KAAvB,qBAAuB;SAAvB,uBAAuB;CACvB,kBAAkB;CAClB,qDAA6C;SAA7C,6CAA6C;CAC7C,8BAAsB;SAAtB,sBAAsB;AACvB;;AAEA;CACC,WAAW;CACX,oBAAa;CAAb,oBAAa;CAAb,aAAa;CACb,wBAAuB;KAAvB,qBAAuB;SAAvB,uBAAuB;CACvB,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;CACnB,mBAAmB;AACpB;;AAEA;CACC,WAAW;CACX,gBAAgB;CAChB,YAAY;CACZ,sBAAmB;IAAnB,mBAAmB;AACpB;;AAEA;CACC,8BAA8B;CAC9B,oCAAoC;CACpC,eAAe;CACf,gBAAgB;CAChB,sBAAsB;CACtB,kBAAkB;CAClB,gBAAgB;AACjB;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,cAAc;CACd,oCAAoC;CACpC,eAAe;CACf,gBAAgB;CAChB,gBAAgB;CAChB,gBAAgB;CAChB,cAAc;AACf;;AAEA,4BAA4B;;AAC5B;CACC,qCAAqC;CACrC,mBAAmB;CACnB,uBAAuB;CACvB,oBAAa;CAAb,oBAAa;CAAb,aAAa;CACb,4BAAsB;CAAtB,6BAAsB;KAAtB,0BAAsB;SAAtB,sBAAsB;CACtB,wBAAuB;KAAvB,qBAAuB;SAAvB,uBAAuB;CACvB,sFAA8E;SAA9E,8EAA8E;CAC9E,8BAAsB;SAAtB,sBAAsB;AACvB;;AAEA;CACC,oBAAa;CAAb,oBAAa;CAAb,aAAa;CACb,4BAAsB;CAAtB,6BAAsB;KAAtB,0BAAsB;SAAtB,sBAAsB;CACtB,WAAW;AACZ;;AAEA;CACC,oBAAa;CAAb,oBAAa;CAAb,aAAa;CACb,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;CACnB,yBAA8B;KAA9B,sBAA8B;SAA9B,8BAA8B;CAC9B,SAAS;CACT,cAAc;CACd,8BAAsB;SAAtB,sBAAsB;CACtB,8CAAsC;CAAtC,sCAAsC;CACtC,mBAAmB;AACpB;;AAEA;CACC,oBAAa;CAAb,oBAAa;CAAb,aAAa;CACb,wBAAuB;KAAvB,qBAAuB;SAAvB,uBAAuB;CACvB,SAAS;CACT,mBAAO;KAAP,aAAO;SAAP,SAAO;AACR;;AAEA;CACC,WAAW;CACX,YAAY;CACZ,kBAAkB;CAClB,yBAAyB;CACzB,oBAAa;CAAb,oBAAa;CAAb,aAAa;CACb,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;CACnB,wBAAuB;KAAvB,qBAAuB;SAAvB,uBAAuB;CACvB,oBAAc;KAAd,cAAc;CACd,kBAAkB;CAClB,8BAA8B;CAC9B,eAAe;CACf,iCAAyB;CAAzB,yBAAyB;AAC1B;;AAEA;CACC,yBAAyB;CACzB,8BAA8B;AAC/B;;AAEA;CACC,WAAW;CACX,YAAY;CACZ,sBAAmB;IAAnB,mBAAmB;AACpB;;AAEA;;GAEG;;AAEH;CACC,WAAW;CACX,YAAY;CACZ,cAAc;AACf;;AAEA;CACC,kBAAkB;CAClB,YAAY;CACZ,WAAW;CACX,WAAW;CACX,YAAY;CACZ,kBAAkB;CAClB,mBAAmB;CACnB,2BAA2B;CAC3B,iDAAyC;SAAzC,yCAAyC;AAC1C;;AAEA;CACC,mBAAO;KAAP,aAAO;SAAP,SAAO;AACR;;AAEA;CACC,2BAA2B;CAC3B,+CAA+C;CAC/C,eAAe;CACf,gBAAgB;CAChB,iBAAiB;CACjB,iBAAiB;CACjB,eAAe;CACf,sBAAsB;AACvB;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,cAAc;CACd,oCAAoC;CACpC,eAAe;CACf,gBAAgB;CAChB,gBAAgB;CAChB,SAAS;CACT,gBAAgB;AACjB;;AAEA;CACC,oBAAc;KAAd,cAAc;CACd,iBAAiB;CACjB,oBAAa;CAAb,oBAAa;CAAb,aAAa;CACb,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;AACpB;;AAEA;CACC,2BAA2B;CAC3B,oCAAoC;CACpC,eAAe;CACf,gBAAgB;CAChB,qBAAqB;CACrB,2BAAoB;CAApB,2BAAoB;CAApB,oBAAoB;CACpB,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;CACnB,QAAQ;CACR,eAAe;CACf,qCAA6B;CAA7B,6BAA6B;AAC9B;;AAEA;;CAEC,2BAA2B;CAC3B,qBAAqB;CACrB,YAAY;AACb;;AAEA;CACC,eAAe;CACf,gBAAgB;CAChB,cAAc;AACf;;AAEA;CACC,cAAc;CACd,eAAe;CACf,gBAAgB;CAChB,cAAc;CACd,eAAe;CACf,YAAY;CACZ,mCAA2B;CAA3B,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,WAAW;CACX,yBAAyB;CACzB,WAAW;CACX,cAAc;AACf;;AAEA,yCAAyC;;AACzC;CACC,gBAAgB;CAChB,WAAW;AACZ;;AAEA;CACC,WAAW;CACX,iBAAiB;CACjB,6BAA6B;AAC9B;;AAEA;CACC,oBAAa;CAAb,oBAAa;CAAb,aAAa;CACb,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;CACnB,yBAA8B;KAA9B,sBAA8B;SAA9B,8BAA8B;CAC9B,mBAAe;KAAf,eAAe;CACf,SAAS;CACT,WAAW;AACZ;;AAEA;CACC,eAAe;CACf,8BAA8B;CAC9B,SAAS;CACT,gBAAgB;AACjB;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,oBAAa;CAAb,oBAAa;CAAb,aAAa;CACb,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;CACnB,SAAS;CACT,mBAAe;KAAf,eAAe;AAChB;;AAEA;CACC,qBAAqB;AACtB;;AAEA;CACC,eAAe;CACf,sCAAsC;CACtC,sCAAsC;CACtC,cAAc;CACd,gBAAgB;CAChB,oBAAoB;CACpB,0BAA0B;CAC1B,WAAW;CACX,eAAe;AAChB;;AAEA;CACC,qBAAyB;KAAzB,kBAAyB;SAAzB,yBAAyB;AAC1B;;AAEA;CACC,wBAAuB;KAAvB,qBAAuB;SAAvB,uBAAuB;AACxB;;AAEA,6BAA6B;;AAC7B;CACC;EACC,aAAa;CACd;;CAEA;EACC,gCAAgC;EAChC,SAAS;CACV;;CAEA;EACC,kBAAkB;CACnB;;CAEA;EACC,kBAAkB;CACnB;;CAEA;EACC,eAAe;CAChB;;CAEA;EACC,eAAe;CAChB;;CAEA;EACC,eAAe;CAChB;AACD;;AAEA;CACC;EACC,kBAAkB;CACnB;;CAEA;EACC,uBAAuB;CACxB;;CAEA;EACC,2BAA2B;EAC3B,gBAAgB;EAChB,SAAS;CACV;;CAEA;EACC,kBAAkB;CACnB;;CAEA;EACC,kBAAkB;CACnB;;CAEA;EACC,gBAAgB;CACjB;;CAEA;EACC,eAAe;CAChB;;CAEA;EACC,eAAe;CAChB;;CAEA;EACC,SAAS;CACV;;CAEA;EACC,SAAS;CACV;;CAEA;EACC,WAAW;EACX,YAAY;CACb;;CAEA;;EAEC,WAAW;EACX,YAAY;CACb;;CAEA;EACC,cAAc;CACf;AACD","sourcesContent":[".space1 {\n\tmargin-bottom: 6px !important;\n}\n\n.space2 {\n\tmargin-bottom: 12px !important;\n}\n\n.space3 {\n\tmargin-bottom: 18px !important;\n}\n\n.space4 {\n\tmargin-bottom: 24px !important;\n}\n\n.space5 {\n\tmargin-bottom: 30px !important;\n}\n\n.space6 {\n\tmargin-bottom: 36px !important;\n}\n\n.space7 {\n\tmargin-bottom: 42px !important;\n}\n\n.spaceTop8 {\n\tmargin-bottom: 48px !important;\n}\n\n.spaceTop1 {\n\tmargin-top: 6px !important;\n}\n\n.spaceTop2 {\n\tmargin-top: 12px !important;\n}\n\n.spaceTop3 {\n\tmargin-top: 18px !important;\n}\n\n.spaceTop4 {\n\tmargin-top: 24px !important;\n}\n\n.spaceTop5 {\n\tmargin-top: 30px !important;\n}\n\n.spaceTop6 {\n\tmargin-top: 36px !important;\n}\n\n.spaceTop7 {\n\tmargin-top: 42px !important;\n}\n\n.spaceTop8 {\n\tmargin-top: 48px !important;\n}\n\n.noMargin {\n\tmargin: 0px !important;\n}\n\n.padding1 {\n\tpadding-bottom: 6px !important;\n}\n\n.padding2 {\n\tpadding-bottom: 12px !important;\n}\n\n.padding3 {\n\tpadding-bottom: 18px !important;\n}\n\n.padding4 {\n\tpadding-bottom: 24px !important;\n}\n\n.padding5 {\n\tpadding-bottom: 30px !important;\n}\n\n.padding6 {\n\tpadding-bottom: 36px !important;\n}\n\n.padding7 {\n\tpadding-bottom: 42px !important;\n}\n\n.paddingTop1 {\n\tpadding-top: 6px !important;\n}\n\n.paddingTop2 {\n\tpadding-top: 12px !important;\n}\n\n.paddingTop3 {\n\tpadding-top: 18px !important;\n}\n\n.paddingTop4 {\n\tpadding-top: 24px !important;\n}\n\n.paddingTop5 {\n\tpadding-top: 30px !important;\n}\n\n.paddingTop6 {\n\tpadding-top: 36px !important;\n}\n\n.paddingTop7 {\n\tpadding-top: 42px !important;\n}\n\n.noPadding {\n\tpadding: 0px !important;\n}\n\n.textBold {\n\tfont-weight: 500 !important;\n}\n\n.textBolder {\n\tfont-weight: 700 !important;\n}\n\n.textNormal {\n\tfont-weight: normal !important;\n}\n\n.spaceBottom20 {\n\tmargin-bottom: 20px;\n}\n\n.spaceBottom10 {\n\tmargin-bottom: 10px;\n}\n\n.marginNone {\n\tmargin: 0;\n}\n\n.spaceBottom15 {\n\tmargin-bottom: 15px;\n}\n\n.marginTopNone {\n\tmargin-top: 0;\n}\n\n.spaceTop11 {\n\tmargin-top: 11px;\n}\n\n.spaceTop21 {\n\tmargin-top: 21px;\n}\n\n.spaceTop20 {\n\tmargin-top: 20px;\n}\n\n.spaceTop10 {\n\tmargin-top: 10px;\n}\n\n/*New Design Text Colors */\n\n.textDarkBlue {\n\tcolor: rgb(20, 39, 94) !important;\n}\n\n.textLightBlue {\n\tcolor: rgb(57, 87, 106) !important;\n}\n\n.textLightSandleGreen {\n\tcolor: rgb(76, 86, 41) !important;\n}\n\n.textLightBrown {\n\tcolor: rgb(115, 79, 33) !important;\n}\n\n.textMediumMaroon {\n\tcolor: rgb(87, 37, 51) !important;\n}\n\n.textBrown {\n\tcolor: rgb(160, 47, 24) !important;\n}\n\n.textMaroon {\n\tcolor: rgb(155, 49, 67) !important;\n}\n\n.textDarkBrown {\n\tcolor: rgb(83, 18, 16) !important;\n}\n\n.textMediumBrown {\n\tcolor: rgb(142, 28, 10) !important;\n}\n\n.textSkyBlue {\n\tcolor: rgb(37, 117, 141) !important;\n}\n\n.textGray {\n\tcolor: rgb(77, 65, 51) !important;\n}","@import '../../components/helpers.css';\n\n/* Page Wrapper with soft wavy background */\n.pageRoot {\n\tposition: relative;\n\tmin-height: 100vh;\n\twidth: 100%;\n\tbackground: linear-gradient(180deg, #f6faff 0%, #edf5fd 55%, #e9f3fd 100%);\n\tdisplay: flex;\n\tflex-direction: column;\n\tbox-sizing: border-box;\n\toverflow: hidden;\n\tfont-family: var(--font-family-base);\n}\n\n/* Top waves (white/light layers over the soft blue base) */\n.pageRoot::before {\n\tcontent: '';\n\tposition: absolute;\n\ttop: 0;\n\tleft: 0;\n\twidth: 100%;\n\theight: clamp(160px, 24vw, 220px);\n\tbackground-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 1440 260' preserveAspectRatio='none'%3E%3Cpath fill='%23ffffff' fill-opacity='0.6' d='M0,95 C180,80 300,150 520,160 C760,172 900,85 1120,95 C1280,102 1370,75 1440,60 L1440,0 L0,0 Z'/%3E%3Cpath fill='%23f8fbff' fill-opacity='0.8' d='M0,50 C220,40 340,105 560,110 C800,115 960,50 1160,60 C1300,66 1380,45 1440,35 L1440,0 L0,0 Z'/%3E%3C/svg%3E\");\n\tbackground-repeat: no-repeat;\n\tbackground-position: top center;\n\tbackground-size: 100% 100%;\n\tpointer-events: none;\n\tz-index: 0;\n}\n\n/* Bottom waves (soft blue layers) */\n.pageRoot::after {\n\tcontent: '';\n\tposition: absolute;\n\tbottom: 0;\n\tleft: 0;\n\twidth: 100%;\n\theight: clamp(140px, 20vw, 170px);\n\tbackground-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 1440 220' preserveAspectRatio='none'%3E%3Cpath fill='%23d9eafb' fill-opacity='0.6' d='M0,150 C200,110 380,170 620,165 C860,160 1040,110 1250,125 C1350,132 1410,150 1440,160 L1440,220 L0,220 Z'/%3E%3C/svg%3E\");\n\tbackground-repeat: no-repeat;\n\tbackground-position: bottom center;\n\tbackground-size: 100% 100%;\n\tpointer-events: none;\n\tz-index: 0;\n}\n\n/* Header */\n.pageHeader {\n\twidth: 100%;\n\tbackground: transparent;\n\tpadding: 18px 48px;\n\tbox-sizing: border-box;\n\tposition: relative;\n\tz-index: 100;\n}\n\n.headerInner {\n\tmargin: 0 auto;\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: space-between;\n\twidth: 100%;\n}\n\n.headerLeft {\n\tdisplay: flex;\n\talign-items: center;\n}\n\n.headerLogoLink {\n\tdisplay: inline-flex;\n\talign-items: center;\n\ttext-decoration: none;\n}\n\n.headerLogo {\n\theight: 38px;\n\twidth: auto;\n\tobject-fit: contain;\n}\n\n.headerNav {\n\tdisplay: flex;\n\talign-items: center;\n\tgap: 22px;\n}\n\n.headerNavLink {\n\tcolor: var(--secondary-oscuro);\n\tfont-size: 15px;\n\tfont-weight: 500;\n\tfont-family: var(--font-family-base);\n\ttext-decoration: none;\n\ttransition: color 0.2s ease;\n\tline-height: 1;\n}\n\n.headerNavLink:hover,\n.headerNavLink:focus {\n\tcolor: var(--primary-color);\n\ttext-decoration: none;\n}\n\n.headerNavLinkActive {\n\tcolor: var(--secondary-oscuro);\n\tfont-weight: 600;\n}\n\n.navDivider {\n\twidth: 1.5px;\n\theight: 50px;\n\tbackground-color: #cbd5e1;\n\tdisplay: inline-block;\n}\n\n.headerRight {\n\tdisplay: flex;\n\talign-items: center;\n}\n\n.dropdownBtn {\n\tdisplay: flex;\n\talign-items: center;\n\tcursor: pointer;\n}\n\n/* Mobile slide menu */\n.mobileMenu {\n\tposition: fixed;\n\ttop: 0;\n\tright: -100%;\n\twidth: 100%;\n\tmax-width: 380px;\n\theight: 100vh;\n\tbackground: var(--background-primary);\n\tz-index: 1050;\n\ttransition: right 0.35s ease;\n\toverflow-y: auto;\n\tbox-shadow: -4px 0 20px rgba(0, 0, 0, 0.15);\n\tpadding: 24px 20px;\n\tbox-sizing: border-box;\n}\n\n.menuOpen {\n\tright: 0 !important;\n}\n\n.closeButtonPosition {\n\tdisplay: flex;\n\tjustify-content: flex-end;\n\tmargin-bottom: 20px;\n}\n\n.closeColor {\n\tcursor: pointer;\n\tpadding: 8px;\n}\n\n.closeColor img {\n\twidth: 18px;\n\theight: 18px;\n}\n\n.mobileMenuContent {\n\twidth: 100%;\n}\n\n/* Main Content Section */\n.mainContainer {\n\tposition: relative;\n\tz-index: 1;\n\tflex: 1;\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\tpadding: 20px 32px 60px;\n\tbox-sizing: border-box;\n\twidth: 100%;\n}\n\n.cardsGrid {\n\tmax-width: 1510px;\n\twidth: 100%;\n\tmargin: 0 auto;\n\tdisplay: grid;\n\tgrid-template-columns: 0.6fr 1fr;\n\tgap: 32px;\n\talign-items: stretch;\n}\n\n/* Left Card (Greeting & Character) */\n.leftCard {\n\t/* background: linear-gradient(180deg, rgba(236, 245, 253, 0.92) 0%, rgba(228, 240, 252, 0.92) 100%); */\n\tbackground-image: url('/public/SiteImages/fondo-ondulado-para-personaje.svg');\n\tbackground-repeat: no-repeat;\n\tbackground-position: center center;\n\tbackground-size: contain;\n\tborder-radius: 30px;\n\tpadding: 44px 32px 40px;\n\tdisplay: flex;\n\tflex-direction: column;\n\talign-items: center;\n\tjustify-content: center;\n\ttext-align: center;\n\tbox-shadow: 0 10px 40px rgba(0, 52, 83, 0.04);\n\tbox-sizing: border-box;\n}\n\n.illustrationWrapper {\n\twidth: 100%;\n\tdisplay: flex;\n\tjustify-content: center;\n\talign-items: center;\n\tmargin-bottom: 24px;\n}\n\n.illustrationImg {\n\twidth: 100%;\n\tmax-width: 340px;\n\theight: auto;\n\tobject-fit: contain;\n}\n\n.leftTitle {\n\tcolor: var(--secondary-oscuro);\n\tfont-family: var(--font-family-base);\n\tfont-size: 42px;\n\tfont-weight: 800;\n\tletter-spacing: -0.5px;\n\tmargin: 0 0 12px 0;\n\tline-height: 1.2;\n}\n\n.leftUserName {\n\tcolor: var(--primary-color);\n}\n\n.leftSubtitle {\n\tcolor: #4b5563;\n\tfont-family: var(--font-family-base);\n\tfont-size: 17px;\n\tfont-weight: 400;\n\tline-height: 1.5;\n\tmax-width: 340px;\n\tmargin: 0 auto;\n}\n\n/* Right Card (Steps List) */\n.rightCard {\n\tbackground: rgba(255, 255, 255, 0.78);\n\tborder-radius: 30px;\n\tpadding: 44px 44px 36px;\n\tdisplay: flex;\n\tflex-direction: column;\n\tjustify-content: center;\n\tbox-shadow: 0 10px 40px rgba(0, 52, 83, 0.05), 0 2px 10px rgba(0, 0, 0, 0.015);\n\tbox-sizing: border-box;\n}\n\n.stepsList {\n\tdisplay: flex;\n\tflex-direction: column;\n\twidth: 100%;\n}\n\n.stepItem {\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: space-between;\n\tgap: 20px;\n\tpadding: 6px 0;\n\tbox-sizing: border-box;\n\ttransition: background-color 0.2s ease;\n\tborder-radius: 16px;\n}\n\n.stepLeft {\n\tdisplay: flex;\n\talign-items: flex-start;\n\tgap: 22px;\n\tflex: 1;\n}\n\n.stepIconCircle {\n\twidth: 58px;\n\theight: 58px;\n\tborder-radius: 50%;\n\tbackground-color: #e4effc;\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\tflex-shrink: 0;\n\tposition: relative;\n\tcolor: var(--secondary-oscuro);\n\tmargin-top: 2px;\n\ttransition: all 0.2s ease;\n}\n\n.stepIconCircleCompleted {\n\tbackground-color: #d9eafb;\n\tcolor: var(--secondary-oscuro);\n}\n\n.stepIconImg {\n\twidth: 24px;\n\theight: 24px;\n\tobject-fit: contain;\n}\n\n/* .stepIconCircleCompleted .stepIconImg {\n\tfilter: brightness(0) invert(1);\n} */\n\n.stepSvgIcon {\n\twidth: 24px;\n\theight: 24px;\n\tdisplay: block;\n}\n\n.stepTickIcon {\n\tposition: absolute;\n\tbottom: -2px;\n\tright: -2px;\n\twidth: 18px;\n\theight: 18px;\n\tborder-radius: 50%;\n\tbackground: #ffffff;\n\tcolor: var(--primary-color);\n\tbox-shadow: 0 2px 6px rgba(0, 0, 0, 0.15);\n}\n\n.stepDetails {\n\tflex: 1;\n}\n\n.stepTitle {\n\tcolor: var(--primary-color);\n\tfont-family: var(--font-family-base) !important;\n\tfont-size: 26px;\n\tfont-weight: 700;\n\tmargin: 0 0 6px 0;\n\tline-height: 1.25;\n\tcursor: pointer;\n\tletter-spacing: -0.3px;\n}\n\n.stepTitle:hover {\n\topacity: 0.85;\n}\n\n.stepDescription {\n\tcolor: #4b5563;\n\tfont-family: var(--font-family-base);\n\tfont-size: 16px;\n\tfont-weight: 400;\n\tline-height: 1.5;\n\tmargin: 0;\n\tmax-width: 520px;\n}\n\n.stepAction {\n\tflex-shrink: 0;\n\tmargin-left: 16px;\n\tdisplay: flex;\n\talign-items: center;\n}\n\n.actionLink {\n\tcolor: var(--primary-color);\n\tfont-family: var(--font-family-base);\n\tfont-size: 16px;\n\tfont-weight: 500;\n\ttext-decoration: none;\n\tdisplay: inline-flex;\n\talign-items: center;\n\tgap: 6px;\n\tcursor: pointer;\n\ttransition: opacity 0.2s ease;\n}\n\n.actionLink:hover,\n.actionLink:focus {\n\tcolor: var(--primary-color);\n\ttext-decoration: none;\n\topacity: 0.8;\n}\n\n.chevronIcon {\n\tfont-size: 22px;\n\tfont-weight: 600;\n\tline-height: 1;\n}\n\n.chevronDisabled {\n\tcolor: #64748b;\n\tfont-size: 26px;\n\tfont-weight: 400;\n\tline-height: 1;\n\tcursor: pointer;\n\tpadding: 4px;\n\ttransition: color 0.2s ease;\n}\n\n.chevronDisabled:hover {\n\tcolor: var(--primary-color);\n}\n\n.stepDivider {\n\theight: 1px;\n\tbackground-color: #e6edf4;\n\twidth: 100%;\n\tmargin: 26px 0;\n}\n\n/* Grid Footer (Publish / Admin status) */\n.gridFooter {\n\tmargin-top: 24px;\n\twidth: 100%;\n}\n\n.listNextPosition {\n\twidth: 100%;\n\tpadding-top: 16px;\n\tborder-top: 1px solid #e6edf4;\n}\n\n.listNextBackButton {\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: space-between;\n\tflex-wrap: wrap;\n\tgap: 16px;\n\twidth: 100%;\n}\n\n.textColor {\n\tfont-size: 15px;\n\tcolor: var(--secondary-oscuro);\n\tmargin: 0;\n\tfont-weight: 600;\n}\n\n.spaceTop1 {\n\tmargin-top: 0;\n}\n\n.btnFlex {\n\tdisplay: flex;\n\talign-items: center;\n\tgap: 12px;\n\tflex-wrap: wrap;\n}\n\n.displayInline {\n\tdisplay: inline-block;\n}\n\n.formSelect {\n\tfont-size: 15px;\n\tborder: 1px solid var(--primary-color);\n\tbackground-color: var(--primary-color);\n\tcolor: #ffffff;\n\tfont-weight: 600;\n\tborder-radius: 999px;\n\tpadding: 8px 32px 8px 18px;\n\twidth: auto;\n\tcursor: pointer;\n}\n\n.flexEnd {\n\tjustify-content: flex-end;\n}\n\n.flexCenter {\n\tjustify-content: center;\n}\n\n/* Responsive Media Queries */\n@media screen and (max-width: 1080px) {\n\t.headerNav {\n\t\tdisplay: none;\n\t}\n\n\t.cardsGrid {\n\t\tgrid-template-columns: 360px 1fr;\n\t\tgap: 24px;\n\t}\n\n\t.leftCard {\n\t\tpadding: 36px 24px;\n\t}\n\n\t.rightCard {\n\t\tpadding: 36px 28px;\n\t}\n\n\t.leftTitle {\n\t\tfont-size: 32px;\n\t}\n\n\t.stepTitle {\n\t\tfont-size: 22px;\n\t}\n\n\t.stepDescription {\n\t\tfont-size: 15px;\n\t}\n}\n\n@media screen and (max-width: 860px) {\n\t.pageHeader {\n\t\tpadding: 14px 20px;\n\t}\n\n\t.mainContainer {\n\t\tpadding: 12px 16px 36px;\n\t}\n\n\t.cardsGrid {\n\t\tgrid-template-columns: 100%;\n\t\tmax-width: 620px;\n\t\tgap: 24px;\n\t}\n\n\t.leftCard {\n\t\tpadding: 32px 20px;\n\t}\n\n\t.rightCard {\n\t\tpadding: 32px 20px;\n\t}\n\n\t.illustrationImg {\n\t\tmax-width: 260px;\n\t}\n\n\t.stepTitle {\n\t\tfont-size: 19px;\n\t}\n\n\t.stepDescription {\n\t\tfont-size: 14px;\n\t}\n\n\t.stepItem {\n\t\tgap: 12px;\n\t}\n\n\t.stepLeft {\n\t\tgap: 14px;\n\t}\n\n\t.stepIconCircle {\n\t\twidth: 44px;\n\t\theight: 44px;\n\t}\n\n\t.stepIconImg,\n\t.stepSvgIcon {\n\t\twidth: 18px;\n\t\theight: 18px;\n\t}\n\n\t.stepDivider {\n\t\tmargin: 20px 0;\n\t}\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"space1": `ExistingPage-space1-RhrA5`,
	"space2": `ExistingPage-space2-KXdcl`,
	"space3": `ExistingPage-space3-PyeNc`,
	"space4": `ExistingPage-space4-KQrao`,
	"space5": `ExistingPage-space5-i9eKx`,
	"space6": `ExistingPage-space6-UpI0P`,
	"space7": `ExistingPage-space7-vHYnS`,
	"spaceTop8": `ExistingPage-spaceTop8-GqvJa`,
	"spaceTop1": `ExistingPage-spaceTop1-sHJA5`,
	"spaceTop2": `ExistingPage-spaceTop2-JGeX9`,
	"spaceTop3": `ExistingPage-spaceTop3-XgVrn`,
	"spaceTop4": `ExistingPage-spaceTop4-Ds6Zf`,
	"spaceTop5": `ExistingPage-spaceTop5-Kyop1`,
	"spaceTop6": `ExistingPage-spaceTop6-moSYM`,
	"spaceTop7": `ExistingPage-spaceTop7-P8QhP`,
	"noMargin": `ExistingPage-noMargin-h2xLH`,
	"padding1": `ExistingPage-padding1-NRv14`,
	"padding2": `ExistingPage-padding2-IB35q`,
	"padding3": `ExistingPage-padding3-wDVvv`,
	"padding4": `ExistingPage-padding4-dbz7W`,
	"padding5": `ExistingPage-padding5-qqmcy`,
	"padding6": `ExistingPage-padding6-i4EEr`,
	"padding7": `ExistingPage-padding7-RulE5`,
	"paddingTop1": `ExistingPage-paddingTop1-qVAKn`,
	"paddingTop2": `ExistingPage-paddingTop2-tIODS`,
	"paddingTop3": `ExistingPage-paddingTop3-NTwmM`,
	"paddingTop4": `ExistingPage-paddingTop4-Wdmha`,
	"paddingTop5": `ExistingPage-paddingTop5-wLrkb`,
	"paddingTop6": `ExistingPage-paddingTop6-INIz3`,
	"paddingTop7": `ExistingPage-paddingTop7-VzDCc`,
	"noPadding": `ExistingPage-noPadding-oFnIy`,
	"textBold": `ExistingPage-textBold-Apo_h`,
	"textBolder": `ExistingPage-textBolder-HzQAw`,
	"textNormal": `ExistingPage-textNormal-E8929`,
	"spaceBottom20": `ExistingPage-spaceBottom20-aL13P`,
	"spaceBottom10": `ExistingPage-spaceBottom10-kz8dv`,
	"marginNone": `ExistingPage-marginNone-j8bkT`,
	"spaceBottom15": `ExistingPage-spaceBottom15-gH5ht`,
	"marginTopNone": `ExistingPage-marginTopNone-eTmfj`,
	"spaceTop11": `ExistingPage-spaceTop11-hNenj`,
	"spaceTop21": `ExistingPage-spaceTop21-eRo70`,
	"spaceTop20": `ExistingPage-spaceTop20-GRcs6`,
	"spaceTop10": `ExistingPage-spaceTop10-l9_Aa`,
	"textDarkBlue": `ExistingPage-textDarkBlue-xAeFT`,
	"textLightBlue": `ExistingPage-textLightBlue-CbfZm`,
	"textLightSandleGreen": `ExistingPage-textLightSandleGreen-IL5rO`,
	"textLightBrown": `ExistingPage-textLightBrown-vIx9S`,
	"textMediumMaroon": `ExistingPage-textMediumMaroon-ky0ug`,
	"textBrown": `ExistingPage-textBrown-AvptE`,
	"textMaroon": `ExistingPage-textMaroon-ThZLW`,
	"textDarkBrown": `ExistingPage-textDarkBrown-dRt_d`,
	"textMediumBrown": `ExistingPage-textMediumBrown-FAlJ4`,
	"textSkyBlue": `ExistingPage-textSkyBlue-bOZMH`,
	"textGray": `ExistingPage-textGray-x5cZ6`,
	"pageRoot": `ExistingPage-pageRoot-siyxP`,
	"pageHeader": `ExistingPage-pageHeader-AgJ9D`,
	"headerInner": `ExistingPage-headerInner-aeAFr`,
	"headerLeft": `ExistingPage-headerLeft-C17lc`,
	"headerLogoLink": `ExistingPage-headerLogoLink-mKC8m`,
	"headerLogo": `ExistingPage-headerLogo-fVWo9`,
	"headerNav": `ExistingPage-headerNav-BaQ4U`,
	"headerNavLink": `ExistingPage-headerNavLink-ROrZz`,
	"headerNavLinkActive": `ExistingPage-headerNavLinkActive-QtZn5`,
	"navDivider": `ExistingPage-navDivider-DdFEg`,
	"headerRight": `ExistingPage-headerRight-FHCE_`,
	"dropdownBtn": `ExistingPage-dropdownBtn-KUBLG`,
	"mobileMenu": `ExistingPage-mobileMenu-mXt7r`,
	"menuOpen": `ExistingPage-menuOpen-zKrwt`,
	"closeButtonPosition": `ExistingPage-closeButtonPosition-kmmne`,
	"closeColor": `ExistingPage-closeColor-Amjhx`,
	"mobileMenuContent": `ExistingPage-mobileMenuContent-hO_6w`,
	"mainContainer": `ExistingPage-mainContainer-B7VJZ`,
	"cardsGrid": `ExistingPage-cardsGrid-Yf4kG`,
	"leftCard": `ExistingPage-leftCard-RspeV`,
	"illustrationWrapper": `ExistingPage-illustrationWrapper-YUnGc`,
	"illustrationImg": `ExistingPage-illustrationImg-gxJ8_`,
	"leftTitle": `ExistingPage-leftTitle-UgSxS`,
	"leftUserName": `ExistingPage-leftUserName-bNZpf`,
	"leftSubtitle": `ExistingPage-leftSubtitle-HXmxN`,
	"rightCard": `ExistingPage-rightCard-CC8VH`,
	"stepsList": `ExistingPage-stepsList-P4w90`,
	"stepItem": `ExistingPage-stepItem-a7rjc`,
	"stepLeft": `ExistingPage-stepLeft-Uyzld`,
	"stepIconCircle": `ExistingPage-stepIconCircle-W17Dt`,
	"stepIconCircleCompleted": `ExistingPage-stepIconCircleCompleted-NCtmy`,
	"stepIconImg": `ExistingPage-stepIconImg-FU_XZ`,
	"stepSvgIcon": `ExistingPage-stepSvgIcon-v8Q82`,
	"stepTickIcon": `ExistingPage-stepTickIcon-l7CEm`,
	"stepDetails": `ExistingPage-stepDetails-HYwwR`,
	"stepTitle": `ExistingPage-stepTitle-Z4aGv`,
	"stepDescription": `ExistingPage-stepDescription-WWHG8`,
	"stepAction": `ExistingPage-stepAction-rl5cv`,
	"actionLink": `ExistingPage-actionLink-mWmrx`,
	"chevronIcon": `ExistingPage-chevronIcon-LMIbc`,
	"chevronDisabled": `ExistingPage-chevronDisabled-BUx9e`,
	"stepDivider": `ExistingPage-stepDivider-uYIgR`,
	"gridFooter": `ExistingPage-gridFooter-kncyJ`,
	"listNextPosition": `ExistingPage-listNextPosition-o8el4`,
	"listNextBackButton": `ExistingPage-listNextBackButton-Jup8e`,
	"textColor": `ExistingPage-textColor-bzt0C`,
	"btnFlex": `ExistingPage-btnFlex-wDTIB`,
	"displayInline": `ExistingPage-displayInline-c100V`,
	"formSelect": `ExistingPage-formSelect-qyOkk`,
	"flexEnd": `ExistingPage-flexEnd-btFc1`,
	"flexCenter": `ExistingPage-flexCenter-ah2wV`
};
module.exports = ___CSS_LOADER_EXPORT___;
